import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountCard } from "@components/financialAccount/AccountCard/AccountCard";
import { FinancialAccount } from "@common/types/financialAccount";
import { useFinancialAccounts } from "@hooks/useFinancialAccounts";
import { HistoryCreatedTransactionDetailsRow } from "../views/historyCreatedTransactionDetailsViewConfig";

export const HistoryCreatedTransactionFinancialAccountCell = ({
    row,
}: CellContext<
    ViewTableFeatures,
    HistoryCreatedTransactionDetailsRow,
    Partial<FinancialAccount>
>) => {
    const { id, name } = row.original.financialAccount ?? {};
    const entity = row.original.entity;

    const accounts = useFinancialAccounts();
    let financialAccount: FinancialAccount | undefined = accounts?.find(
        (account) => account.id === id,
    );

    if (!financialAccount) {
        financialAccount = {
            id,
            name: name ?? "",
            entityId: entity?.id,
            entity,
        } as FinancialAccount;
    }

    return (
        <ViewTableCell>
            <AccountCard
                account={financialAccount}
                showType={false}
                iconSize="sm"
            />
        </ViewTableCell>
    );
};
